const ErrorMsg = (props) => {
  return (
    <p id="outlined_error_help" className="ml-2 mt-1.5 fs-xs text-red-600 dark:text-red-400">
      {props.children}
    </p>
  )
}

export default ErrorMsg